export type MetricValue = {
  value: string;
  label: string;
  isPositive: boolean;
};

export const principleMetrics: Record<string, MetricValue[]> = {
  "DOC 01": [
    { value: "+12.4%", label: "Yield Rate", isPositive: true },
    { value: "-3.2%", label: "Drift", isPositive: false },
    { value: "+19.1%", label: "Δ NAV", isPositive: true },
    { value: "-10.8%", label: "Volatility", isPositive: false },
  ],
  "DOC 02": [
    { value: "+8.7%", label: "Hedge Efficiency", isPositive: true },
    { value: "-2.1%", label: "Exposure Drift", isPositive: false },
    { value: "+15.3%", label: "PnL Attribution", isPositive: true },
    { value: "-5.4%", label: "Risk Deviation", isPositive: false },
  ],
  "DOC 03": [
    { value: "+22.1%", label: "Backtest Accuracy", isPositive: true },
    { value: "-1.8%", label: "Simulation Error", isPositive: false },
    { value: "+18.6%", label: "Reproducibility", isPositive: true },
    { value: "-4.2%", label: "Validation Gap", isPositive: false },
  ],
};

